import React from 'react';
import { ResponsiveBar } from '@nivo/bar';

import { PatternDots, PatternLines, Defs } from '@nivo/core';
import { Empty, Space } from "antd";
import {Square} from 'lucide-react';

const CumulativeRecoveryWaterfallChart = ({ data }) => {
    // Prepare the data for the waterfall format
    if (!data.some(item => item.worst < 0)) {
        return <Empty description="No Items With Negative Drawdowns in Window" />;
    }

    const formattedData = data
        .filter(item => item.worst < 0)  // Filter out items with no drawdown
        .map(item => ({
            id: item.label,
            drawdown: item.worst,  // Drawdown in negative to show fall
            recovery: item.backToEven,  // Recovery is a positive value
        }))
        .sort((a, b) => a.recovery - b.recovery);

    return (
            <ResponsiveBar
            data={formattedData}
            keys={['drawdown', 'recovery']}
            indexBy="id"
            margin={{ top: 10, right: 50, bottom: 50, left: 180 }}
            padding={0.6}
            layout="horizontal"
            defs={[
                // Define gradient for recovery bars (green)
                {
                    id: 'gradientGreen',
                    type: 'linearGradient',
                    colors: [
                        { offset: 0, color: '#1b5b42' },
                        { offset: 100, color: '#0dd083' }
                    ],
                    x1: "0%", y1: "0%", x2: "100%", y2: "0%" // Left to right gradient

                },
                // Define gradient for drawdown bars (red)
                {
                    id: 'gradientRed',
                    type: 'linearGradient',
                    colors: [
                        { offset: 0, color: '#f63e3e' },
                        { offset: 100, color: '#732b2b' }
                    ],
                    x1: "0%", y1: "0%", x2: "100%", y2: "0%" // Left to right gradient

                },
                // Define pattern for drawdown bars
                {
                    id: 'checkeredPattern',
                    type: 'patternLines',
                    background: 'inherit',
                    color: '#e6492d',
                    rotation: -45,
                    lineWidth: 4,
                    spacing: 6
                }
            ]}
            fill={[
                { match: { id: 'drawdown' }, id: 'gradientRed' },
                { match: { id: 'drawdown' }, id: 'checkeredPattern' },
                { match: { id: 'recovery' }, id: 'gradientGreen' }
            ]}
            colors={({ id, data }) => {
                // Use gradients as defined in defs
                return id === 'drawdown' ? 'url(#gradientRed)' : 'url(#gradientGreen)';
            }}
            borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: 'Percentage',
                legendPosition: 'middle',
                legendOffset: 32
            }}
            axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: '',
                legendPosition: 'middle',
                legendOffset: -40,
                format: value => `${value}`.length > 20 ? `${value.substring(0, 17)}...` : value,
                tickLabelWidth: 150,
                tickLabelHeight: 20,
                wrap: true
            }}
            labelSkipWidth={12}
            labelSkipHeight={12}
            label={({ value }) => `${(value * 100).toFixed(1)}%`}
            labelTextColor={{ from: 'color', modifiers: [['brighter', 1.6]] }}
            animate={true}
            motionStiffness={90}
            motionDamping={15}
            legends={[]}
        />
    );
};

export default CumulativeRecoveryWaterfallChart;
